import { render, staticRenderFns } from "./DM_flowBackList.vue?vue&type=template&id=0009544e&"
import script from "./DM_flowBackList.vue?vue&type=script&lang=js&"
export * from "./DM_flowBackList.vue?vue&type=script&lang=js&"
import style0 from "./DM_flowBackList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports